<nuc-button styleClass="hamburger-menu-button" size="32" (click)="openDialog()"
    prefixIcon="stla-hamburger-menu"></nuc-button>